/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type SharedRespLinksBlock_links = ReadonlyArray<{
    readonly url: string | null;
    readonly anchorText: string | null;
    readonly " $refType": "SharedRespLinksBlock_links";
}>;
export type SharedRespLinksBlock_links$data = SharedRespLinksBlock_links;
export type SharedRespLinksBlock_links$key = ReadonlyArray<{
    readonly " $data"?: SharedRespLinksBlock_links$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_links">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SharedRespLinksBlock_links",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "anchorText",
      "storageKey": null
    }
  ],
  "type": "InternalBuyLinkType",
  "abstractKey": null
};
(node as any).hash = '1a3b3ca9ce0eddc9a235d71394dd478d';
export default node;
